import { Place } from '@/types/google-maps.types';

const countrySuffixRegex = /,\s*(?:brasil|brazil)\s*$/i;
const zipcodeSuffixRegex = /,\s*\d{5}-?\d{3}\s*$/;

const withoutCountryAndZipcode = (address: string): string =>
  address
    .replace(countrySuffixRegex, '')
    .replace(zipcodeSuffixRegex, '')
    .trim();

export const formatLocationLabel = (place?: Place): string => {
  if (!place) {
    return '';
  }

  if (place.city && place.state) {
    return `${place.city} - ${place.state}`;
  }

  return withoutCountryAndZipcode(place.formattedAddress);
};
